exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "div.footerRow {\n  height: 330px;\n  width: 100%;\n  margin-top: 40px;\n  color: #ffffff;\n  text-align: center;\n  font-size: 12px;\n  background: url(" + require("../../../assets/img/footer.jpg") + ") center center no-repeat;\n  background-size: cover; }\n  div.footerRow div.footerTop {\n    height: 280px;\n    background-color: rgba(20, 21, 69, 0.6);\n    overflow: hidden; }\n    div.footerRow div.footerTop a#footerYildizlarLogo {\n      width: 210px;\n      height: 180px;\n      display: block;\n      margin: 30px auto 10px;\n      background: url(" + require("../../../assets/img/yildizlar-sss-holding-logo.svg") + ") center center no-repeat;\n      background-size: contain; }\n  div.footerRow div.footerBottom {\n    line-height: 50px;\n    background-color: rgba(20, 21, 69, 0.9); }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/emrevolkanucar/Desktop/Angular/etigumus/src/app/share/footer/footer.component.scss
// module id = ../../../../../src/app/share/footer/footer.component.scss
// module chunks = main